'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React from 'react';
import { createContext, useEffect, useRef } from 'react';

import { usePathname } from 'next/navigation';
import PropTypes from 'prop-types';

export const PreviousPathnameContext = createContext(null);

export const PreviousPathnameProvider = ({ children }) => {
    const pathname = usePathname();
    const ref = useRef();

    useEffect(() => {
        ref.current = pathname;
    }, [pathname]);

    return (
        <PreviousPathnameContext.Provider value={ref.current}>
            {children}
        </PreviousPathnameContext.Provider>
    );
};

PreviousPathnameProvider.propTypes = {
    children: PropTypes.node.isRequired,
};
